export class NaviosViagensModel {
  id: number;
  id_navio: number = 0;
  id_porto_carregamento: number = 0;
  id_porto_descarga: number = 0;
  enviado_bordo: string;
  eta: string;
  data_descarga: string;
}



// WEBPACK FOOTER //
// ./src/app/navios-viagens/navios-viagens.model.ts